import { motion } from "framer-motion";
import { useEffect, useRef, useState } from 'react';
import CardMenu from '../components/layouts/CardMenu';
import { apiFetch } from "../lib/apiFetch";
type MenuDetail = {
    id: number;
    name: string;
    price: number;
    isrecommend: boolean;
};

type Menu = {
    id: number;
    title: string;
    description: string;
    menu_details: MenuDetail[];
};

type Menus = Menu[];
export const Menu = () => {
    const [listData, setListData] = useState<Menus | null>([])
    const apiKopilibrasi = import.meta.env.VITE_KOPILIBRASI_URL_PG
    const ref = useRef(null)
    const fetchData = async () => {
        // const response = await fetch(`${supabaseUrl}/rest/v1/rpc/get_menus_collection?apikey=${supabaseKey}`)
        const response = await apiFetch(`${apiKopilibrasi}/get_menus`,
            {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
        if (response.ok) {
            const menu_views = await response.json() as Menus
            setListData(menu_views)
        }
    }
useEffect(() => {
    fetchData()
}, [])
return (
    <>
        <div className="w-full h-full">
            <div className='lg:px-32 px-5 pt-6 pb-4'>
                <h1 className="font-semibold text-center text-4xl">
                    Our Menu
                </h1>
                {
                    listData && listData.map((data: Menu) => {
                        return (
                            <motion.div
                                key={data.id}
                                ref={ref}>
                                <CardMenu key={data.id} title={data.title} description={data.description} list={data.menu_details} />
                            </motion.div>
                        )
                    })
                }
                {/* <motion.div
                        ref={ref}>
                        <CardMenu key={1} title="Coffee Based" description="Minuman yang menggunakan kopi sebagai bahan utama, seperti espresso, cappuccino, yang dapat dinikmati dalam berbagai variasi rasa dan tekstur." list={listCoffee} />
                    </motion.div>
                    <motion.div
                        ref={ref}>
                        <CardMenu key={2} title="Tea Based" description="Minuman yang menggunakan teh sebagai bahan utama yang dapat dinikmati dalam berbagai variasi rasa." list={listTea} />
                    </motion.div>
                    <motion.div
                        ref={ref}>
                        <CardMenu key={3} title="Milk Based" description="Minuman yang menggunakan susu sebagai bahan utama yang dapat dinikmati dalam berbagai variasi rasa." list={listMilk} />
                    </motion.div>
                    <motion.div
                        ref={ref}>
                        <CardMenu key={4} title="Snack and Food" description="Cemilan yang enak dan cocok sebagai teman minum kopi mu." list={listSnacks} />
                    </motion.div> */}
            </div>
        </div>
    </>
)
}

